
export const ADDCOUNTID = "ADDCOUNTID";
export const REDUCECOUNTID = "REDUCECOUNTID";


export const CHECKGOODS = "CHECKGOODS";
export const CHECKRETURNGOODS = "CHECKRETURNGOODS";
export const CURUSER = "CURUSER";
export const GODETAIL = "GODETAIL";
// export const GOPAY = "GOPAY";
export const GOPAY1 = "GOPAY1";
export const USERINFO = "USERINFO";
export const TYPEID = "TYPEID";
export const TYPENAME = "TYPENAME";
export const TYPEGRADE = "TYPEGRADE";
export const ADDPRODUCECAR = "ADDPRODUCECAR";
export const ADDNAV = "ADDNAV";

export const GOEDIT = "GOEDIT";
export const PRODUCELIST = "PRODUCELIST";
export const ORDERPAY = "ORDERPAY";
export const NUM = "NUM";
export const CLIENTID = "CLIENTID";

export const GOCLIENTID = "GOCLIENTID";

// export const GOODS = "GOODS";
// export const GOPAY1 = "GOPAY1";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js